import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div className="font-jost w-full max-w-4xl mx-auto px-6 py-16 md:py-24 text-gray-800 bg-white min-h-screen">
      <h1 className="text-3xl md:text-5xl font-bold mb-8 text-black">Privacy Policy</h1>
      
      <div className="space-y-6 leading-relaxed">
        <p><strong>Effective Date:</strong> {new Date().toLocaleDateString()}</p>
        
        <h2 className="text-xl font-semibold mt-8 text-black">1. Information We Collect</h2>
        <p>We collect personal information that you voluntarily provide to us when registering at the website, expressing an interest in obtaining information about us or our products, or otherwise contacting us.</p>
        <p>The personal information that we collect depends on the context of your interactions with us and the website, the choices you make and the products and features you use.</p>

        <h2 className="text-xl font-semibold mt-8 text-black">2. How We Use Your Information</h2>
        <p>We process your information for purposes based on legitimate business interests, the fulfillment of our contract with you, compliance with our legal obligations, and/or your consent.</p>
        
        <h2 className="text-xl font-semibold mt-8 text-black">3. Will Your Information Be Shared With Anyone?</h2>
        <p>We only share information with your consent, to comply with laws, to provide you with services, to protect your rights, or to fulfill business obligations.</p>
        
        <h2 className="text-xl font-semibold mt-8 text-black">4. How Long Do We Keep Your Information?</h2>
        <p>We keep your information for as long as necessary to fulfill the purposes outlined in this privacy policy unless otherwise required by law.</p>

        <h2 className="text-xl font-semibold mt-8 text-black">5. Contact Us</h2>
        <p>If you have questions or comments about this policy, you may email us at <strong>info@wittynailtip.com</strong> or by post to:</p>
        <p>Houston, TX, USA.</p>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
